import axios, { AxiosInstance } from "axios";
import { configurationService } from "../../../appConfigService";

class HttpClient {
    private _instance: AxiosInstance | null = null;

    get instance(): AxiosInstance {
        if (this._instance === null) {
            this._instance = axios.create({
                baseURL: configurationService.configuration.baseAddress,
            });
        }
        
        return this._instance;
    }
}

export const httpClient = new HttpClient();